import React, { useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import SlideoutMenuTutorial from './SlideoutMenuTutorial';
import maybe from 'components/@common/enhancers/maybe';
import { dequeueTour, queueTour, advanceTourStep } from 'state/modules/tour';
import { getCurrentStep } from 'state/modules/tour/selectors';
import { toggleOnboardingNavigationMenuOverlay } from 'state/modules/ui/actions';
import { useSelector, useDispatch } from 'react-redux';
import { useModal } from '@lwtears/lwt-common-frontend/lib/Modal';
import WelcomeModal from 'components/@common/Modals/Welcome';
import { sendWelcomeEmail } from 'state/modules/user/thunks';
import { hasClickAwayOnly } from 'state/modules/user/selectors/user-selectors';

type Props = {
  open: boolean;
};

const MaybeSlideoutMenuTutorial: any = maybe(SlideoutMenuTutorial);

const OnboardingTour: React.FC<Props> = props => {
  const [{ isOpen: isModalOpen }, { openModal, closeModal }] = useModal();
  const classes = useStyles();
  const tourState = useSelector(({ tour }: any) => tour);
  const user = useSelector(({ user }: any) => user);
  const ui = useSelector(({ ui }: any) => ui);
  const dispatch = useDispatch() as any;

  const shouldDoOnboardingTour = props.open;
  const isClickAwayOnly = useSelector(state => hasClickAwayOnly(state));
  const currentStep = getCurrentStep(tourState);

  useEffect(() => {
    if (shouldDoOnboardingTour && !tourState.queuedTours.includes('onboarding')) {
      dispatch(queueTour('onboarding', true));
    }
  }, [dispatch, shouldDoOnboardingTour, tourState]);

  useEffect(() => {
    if (!shouldDoOnboardingTour) return;
    const close = () => {
      dispatch(advanceTourStep());
      closeModal();
    };
    if (!isModalOpen && currentStep?.name === 'welcomeModal') {
      openModal({
        body: <WelcomeModal closeModal={close} />,
        Title: undefined,
        titleText: 'Welcome',
        handleOnClose: () => {
          dispatch(advanceTourStep());
        }
      });
    } else if (!ui.onboardingNavigationOverlayOpen && currentStep?.name === 'navigationOverlay') {
      dispatch(toggleOnboardingNavigationMenuOverlay());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalOpen, openModal, currentStep, ui, dispatch, shouldDoOnboardingTour]);

  const handleCloseMenuOverlay = () => {
    if (currentStep) {
      dispatch(advanceTourStep());
      dispatch(dequeueTour());
      sendWelcomeEmail();
    }
    dispatch(toggleOnboardingNavigationMenuOverlay());
  };

  return (
    <div className={classes.wrapperContainer}>
      <MaybeSlideoutMenuTutorial
        shouldRender={ui.onboardingNavigationOverlayOpen && !isClickAwayOnly}
        toggleOnboardingNavigationMenuOverlay={handleCloseMenuOverlay}
        product={user.licenses?.[0]?.productCurriculumId}
        imageUrl={currentStep?.imageUrl}
      />
    </div>
  );
};

const useStyles = makeStyles(() => {
  return {
    wrapperContainer: {}
  };
});

export default OnboardingTour;
